module.exports = __webpack_public_path__ + "static/img/am.8a063b9e.svg";